import React from 'react';
import { Container, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const AboutSectionSkeleton = () => (
  <Container maxWidth="xxl">
    <Grid container spacing={2}>
      <Grid item xs={12} md={2} className="paragraphGrid">
        <Skeleton variant="text" height={40} width="60%" />
        <Skeleton variant="text" height={40} width="80%" />
      </Grid>
      <Grid item xs={12} md={6} className="ASImgGrid">
        <Skeleton variant="rectangular" width="100%" height={590} />
      </Grid>
      <Grid item xs={12}>
        <Skeleton variant="text" width="20%" height={40} />
      </Grid>
    </Grid>
  </Container>
);
export { AboutSectionSkeleton };
